import ContactInfo from "@/components/contact/ContactInfo";
import ContactForm from "@/components/contact/ContactForm";

export default function Contact() {
  return (
    <section
      id="contact"
      className="border-b border-[#0A0A0A] bg-[#0A0A0A] text-[#FFFFFF]"
      data-testid="contact-section"
    >
      <div className="max-w-[1440px] mx-auto px-4 md:px-8 py-24 md:py-32 grid grid-cols-12 gap-6 md:gap-12">
        <ContactInfo />
        <ContactForm />
      </div>
    </section>
  );
}
